export default {
    entityKey: 'testing-test-definitions',
    basePath: '/test-definitions',
    titles: {
        singular: 'Test Definition',
        plural: 'Test Definitions'
    }
}
